var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "10px",
    viewBox: "0 0 18 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sections/Top",
    transform: "translate(-926.000000, -25.000000)",
    fill: "#7F7F7F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Top",
    transform: "translate(0.000000, -12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Utility-Menu",
    transform: "translate(242.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User",
    transform: "translate(490.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.197708,21.2388333 C198.90746,20.9683776 198.45516,20.9763579 198.174634,21.2568842 C197.894107,21.5374106 197.886127,21.9897107 198.156583,22.2799585 L206.014132,30.1375071 L198.156583,37.7200415 C197.886127,38.0102893 197.894107,38.4625894 198.174634,38.7431158 C198.45516,39.0236421 198.90746,39.0316224 199.197708,38.7611667 L207.958875,30.1375071 L199.197708,21.2388333 Z",
    id: "Shape",
    transform: "translate(202.958875, 30.000000) rotate(-270.000000) translate(-202.958875, -30.000000) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.7e089ef894497c23d5e9a4c95a150e9e.svg";
export { ForwardRef as ReactComponent };